<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" id="fm2">
<p class="ach">By Nicole Peeler</p>
<p class="achs">J<span class="smallcap">ANE</span> T<span class="smallcap">RUE</span> N<span class="smallcap">OVELS</span></p>
<p class="acl">Tempest Rising</p>
<p class="acl">Tracking the Tempest</p>
<p class="acl">Tempest's Legacy</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780316076012_epub_fm2_r1.vue?1459e2d2